/**
 * Browser and OS detection utility functions
 */

/**
 * Detects browser name and version from user agent
 * @returns {Object} Object containing browserName and browserVersion
 */
export const detectBrowser = () => {
  const ua = navigator.userAgent;
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';

  // Detect browser
  if (ua.indexOf('Firefox') > -1) {
    browserName = 'Firefox';
    browserVersion = ua.match(/Firefox\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
    browserName = 'Chrome';
    browserVersion = ua.match(/Chrome\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
    browserName = 'Safari';
    browserVersion = ua.match(/Version\/([0-9.]+)/)?.[1] || 'Unknown';
  } else if (ua.indexOf('Edg') > -1) {
    browserName = 'Edge';
    browserVersion = ua.match(/Edg\/([0-9.]+)/)?.[1] || 'Unknown';
  }

  return { browserName, browserVersion };
};

/**
 * Detects operating system from user agent
 * @returns {string} Operating system name
 */
export const detectOS = () => {
  const ua = navigator.userAgent;
  let os = 'Unknown';

  if (ua.indexOf('Windows') > -1) os = 'Windows';
  else if (ua.indexOf('Mac') > -1) os = 'macOS';
  else if (ua.indexOf('Linux') > -1) os = 'Linux';
  else if (ua.indexOf('Android') > -1) os = 'Android';
  else if (ua.indexOf('iOS') > -1 || ua.indexOf('iPhone') > -1 || ua.indexOf('iPad') > -1) os = 'iOS';

  return os;
};

/**
 * Gets complete browser and OS information
 * @returns {string} Formatted string with browser, version, and OS
 */
export const getBrowserInfo = () => {
  const { browserName, browserVersion } = detectBrowser();
  const os = detectOS();
  return `${browserName} ${browserVersion} on ${os}`;
};
